import '@angular/core';
import '@angular/common';
import '@angular/compiler';
import '@angular/forms';
import 'ngx-bootstrap';
// import 'jquery';
import 'lodash';
import 'moment';
import 'moment-timezone';
// import 'rxjs';
// import 'zone.js';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';

// pipes
import { CurrencyOrDefaultPipe } from './pipes/currency-or-default.pipe';
import { DateOrDefaultPipe } from './pipes/date-or-default.pipe';
import { NumberOrDefaultPipe } from './pipes/number-or-default.pipe';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { PhoneNumberWithExtPipe } from './pipes/phone-number-with-ext.pipe';
import { SocialSecurityNumberPipe } from './pipes/ssn.pipe';
import { StringOrDefaultPipe } from './pipes/string-or-default.pipe';

import { InputBaseComponent } from './components/forms/ld-input-base/ld-input-base.component';
import { GenericInputComponent } from './components/forms/ld-input-generic/ld-input-generic.component';
import { Utils } from './services/utils.service';
import { FormValidationService } from './services/form-validation.service';
import { LeftNavComponent } from './components/left-nav/left-nav.component';
import { LeftNavBodyComponent } from './components/left-nav/left-nav-body/left-nav-body.component';
import { LeftNavHeaderComponent } from './components/left-nav/left-nav-header/left-nav-header.component';
import { LeftNavLinkComponent } from './components/left-nav/left-nav-link/left-nav-link.component';
import { LeftNavLinksComponent } from './components/left-nav/left-nav-links/left-nav-links.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { SectionSubheaderComponent } from './components/section-subheader/section-subheader.component';
import { SectionSubtitleComponent } from './components/section-subtitle/section-subtitle.component';
import { DateInputComponent } from './components/forms/ld-date-input/ld-date-input.component';
import { LDModalComponent } from './components/modal/ld-modal.component';
import { CurrencyInputComponent } from './components/forms/ld-currency-input/ld-currency-input.component';
import { FooterCTAComponent } from './components/footer-cta/footer-cta.component';
import { LDPopoverComponent } from './components/popover/ld-popover.component';
import { PercentInputComponent } from './components/forms/ld-percent-input/ld-percent-input.component';
import { PhoneInputComponent } from './components/forms/ld-phone-input/ld-phone-input.component';
import { EmailInputComponent } from './components/forms/ld-email-input/ld-email-input.component';
import { UlaSvgIconModule } from '../shared/svg-icon/ula-svg-icon.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    ReactiveFormsModule,
    UlaSvgIconModule
  ],
  declarations: [
    InputBaseComponent,
    GenericInputComponent,
    DateInputComponent,
    CurrencyInputComponent,
    PercentInputComponent,
    PhoneInputComponent,
    EmailInputComponent,
    LeftNavComponent,
    LeftNavBodyComponent,
    LeftNavHeaderComponent,
    LeftNavLinkComponent,
    LeftNavLinksComponent,
    SectionSubheaderComponent,
    SectionSubtitleComponent,
    LDModalComponent,
    FooterCTAComponent,
    LDPopoverComponent,

    // pipes
    CurrencyOrDefaultPipe,
    DateOrDefaultPipe,
    NumberOrDefaultPipe,
    PhoneNumberPipe,
    PhoneNumberWithExtPipe,
    SocialSecurityNumberPipe,
    StringOrDefaultPipe
  ],
  exports: [
    InputBaseComponent,
    GenericInputComponent,
    DateInputComponent,
    CurrencyInputComponent,
    PercentInputComponent,
    PhoneInputComponent,
    EmailInputComponent,
    LeftNavComponent,
    LeftNavBodyComponent,
    LeftNavHeaderComponent,
    LeftNavLinkComponent,
    LeftNavLinksComponent,
    SectionSubheaderComponent,
    SectionSubtitleComponent,
    LDModalComponent,
    LDPopoverComponent,

    // pipes
    CurrencyOrDefaultPipe,
    DateOrDefaultPipe,
    NumberOrDefaultPipe,
    PhoneNumberPipe,
    PhoneNumberWithExtPipe,
    SocialSecurityNumberPipe,
    StringOrDefaultPipe
  ],
  providers: [
    Utils,
    FormValidationService
  ]
})
export class LDComponentsModule {
}
